import {useEffect} from 'react';
import {Route, Routes, useLocation} from 'react-router-dom';

import ProtectedRoute from './CommonComponents/ProtectedRoute/ProtectedRoute';
import ResetPasswordComponent from './CommonComponents/ResetPasswordComponent/ResetPasswordComponent';
import AdminDashboard from './ScreenComponent/AdminScreens/AdminScreen';
import {AuthLayout} from './ScreenComponent/AuthLayout';

function App() {
  const {pathname} = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  return (
    <div className={'text-center text-2xl font-semibold'}>
      <Routes>

        {/* Auth Routes */}
        <Route path={'/'} element={<AuthLayout />} />

        <Route
          path={'/forgot-password'}
          element={<ResetPasswordComponent />}
        />

        {/* ADMIN ROUTES */}
        <Route
          path={'/admin/*'}
          element={(
            <ProtectedRoute allowedRoles={['ADMIN']}>
              <AdminDashboard />
            </ProtectedRoute>
          )}
        />

        {/* ACCOUNTANT ROUTES */}
        <Route
          path={'/accountant/*'}
          element={(
            <ProtectedRoute allowedRoles={['ACCOUNTANT']}>
              <AdminDashboard />
            </ProtectedRoute>
          )}
        />

        {/* SUPERVISOR ROUTES */}
        <Route
          path={'/supervisor/*'}
          element={(
            <ProtectedRoute allowedRoles={['SUPERVISOR']}>
              <AdminDashboard />
            </ProtectedRoute>
          )}
        />

      </Routes>
    </div>
  );
}

export default App;
